<template>
    <div class="group-item-item vehicle-item" @click.stop="handleSelect">
        <div class="check-container">
            <font-awesome-icon icon="check" v-if="selected"></font-awesome-icon>
        </div>
        <div class="device-icon" :class="['type'+item.icon]"></div>
        <h2 class="device-name">
            <span>{{ item.name }}</span>
            <br>
            <em>{{ item.regPlate }}</em>
        </h2>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {
            selected(){
                return this.item.selected
            }
        },
        created: function () {

        },
        data() {
            return {
                //selected: false
            }
        },
        destroyed: function () {

        },
        methods: {
            handleSelect(){
                //this.selected = !this.selected
                this.$emit('selected',this.item,!this.selected)
            }
        },
        mounted: function () {

        },
        name: '',
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .vehicle-item{
        display: flex;
        align-items: center;
        border-bottom: solid ($form-elements-border-size / 2) lighten($main-color,25%);
        padding: 10px;
        background-color: $main-white;


        &:last-child{
            border-bottom: none;
        }

        .check-container{
            width: 30px;
            height: 30px;
            align-items: center;
            border: solid 1px $main-color;
            border-radius: 4px;
            cursor: pointer;
            flex: 0 0 30px;
            margin-right: 10px;
            justify-content: center;
            display: flex;

            svg{
                color: $main-color;

            }
        }

        span{
            flex: 1 1 100%;
        }

        &>.svg-inline--fa{
            flex: 0 0 30px;
            cursor: pointer;
        }

        .device-icon{
            width: 44px;
            height: 44px;
            display: block;
            background-repeat: no-repeat;

            /*&.type1{
                background-image: url(../img/device/16.png);
            }*/
            @for $i from 1 through 20 {
                &.type#{$i} {
                        background-image: url(https://rc.suivideflotte.net/img/device/#{$i}.png);
                        background-position: 0 -132px;

                }
            }
        }

        .device-name{
            transition: opacity .2s ease-out;
            font-size: 16px;
            font-weight: 700;
            overflow: hidden;
            position: relative;
            margin: 0 0 0 10px;


            span{
                /*color: #fff;
                text-shadow: 0 1px 1px rgba(0,0,0,.7);*/
            }

            em{
                font-size: .85em;
                opacity: .7;
                color: rgba(0,0,0,.9);
                font-weight: 400;
            }
        }

        &:hover{
            background-color: lighten($main-color,45%);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/formbuilder/renderers/groupItem/VehicleItem.vue